import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const primaryApp = getApps().length ? getApp() : initializeApp(firebaseConfig)
const adminApp =
  getApps().find((a) => a.name === 'admin-secondary') ??
  initializeApp(firebaseConfig, 'admin-secondary')

const auth = getAuth(primaryApp)
const secondaryAuth = getAuth(adminApp)
const db = getFirestore(primaryApp)
const storage = getStorage(primaryApp)
const functions = getFunctions(primaryApp)

// Point every SDK at the local emulator suite. Ports must match the
// `emulators` block in firebase.json. Both auth instances are connected:
// `secondaryAuth` lives on its own app and would otherwise reach production.
if (import.meta.env.VITE_USE_EMULATORS === 'true') {
  const host = import.meta.env.VITE_EMULATOR_HOST || '127.0.0.1'
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true })
  connectAuthEmulator(secondaryAuth, `http://${host}:9099`, { disableWarnings: true })
  connectFirestoreEmulator(db, host, 8080)
  connectStorageEmulator(storage, host, 9199)
  connectFunctionsEmulator(functions, host, 5001)
  console.info(`[firebase] using emulators at ${host}`)
}

export { primaryApp as app, auth, db, storage, functions, secondaryAuth }
